<div class="bg-white">
  @if(!loading){
  <!-- Filters Bar -->
  <div class="px-6 py-4 border-b border-gray-100 bg-gray-50/50">
    <div class="flex flex-wrap items-end gap-4">
      <!-- Employee Filter -->
      <div class="min-w-[210px]">
        <div class="flex items-center justify-between gap-2 mb-1.5">
          <label class="block text-xs font-medium text-gray-500">Employee</label>
          @if(archivedEmployeeCount > 0) {
          <label class="flex items-center gap-1 text-[10px] font-medium text-gray-500 hover:text-gray-700 cursor-pointer whitespace-nowrap"
                 title="Archived employees are hidden by default">
            <input type="checkbox" [(ngModel)]="showArchivedEmployees"
                   class="w-3 h-3 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer">
            Archived ({{ archivedEmployeeCount }})
          </label>
          }
        </div>
        <div class="relative">
          <select [(ngModel)]="selectedEmployeeId" (change)="onFilterChange()" class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                     focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                     hover:border-gray-300 outline-none cursor-pointer transition-all">
            <option value="">All employees</option>
            @for(emp of visibleEmployees; track emp.id){
            <option [value]="emp.cognitoId">{{ emp.firstName }} {{ emp.name }}{{ emp.isArchived ? ' (archived)' : '' }}</option>
            }
          </select>
          <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      <!-- Date Range -->
      <div class="flex items-end gap-2">
        <div>
          <label class="block text-xs font-medium text-gray-500 mb-1.5">From</label>
          <input type="date" (change)="onFilterChange()" [(ngModel)]="startTime" class="px-3 py-2 rounded-lg text-sm bg-white border border-gray-200
                     focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                     hover:border-gray-300 outline-none transition-all">
        </div>
        <span class="text-gray-400 pb-2">→</span>
        <div>
          <label class="block text-xs font-medium text-gray-500 mb-1.5">To</label>
          <input type="date" (change)="onFilterChange()" [(ngModel)]="endTime" class="px-3 py-2 rounded-lg text-sm bg-white border border-gray-200
                     focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                     hover:border-gray-300 outline-none transition-all">
        </div>
      </div>

      <!-- Approval Status filter -->
      <div class="min-w-[160px]">
        <label class="block text-xs font-medium text-gray-500 mb-1.5">Status</label>
        <div class="relative">
          <select [(ngModel)]="approvalStatusFilter" (change)="onFilterChange()" class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                     focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                     hover:border-gray-300 outline-none cursor-pointer transition-all">
            <option value="">All statuses</option>
            <option value="DRAFT">Draft</option>
            <option value="APPROVED">Approved</option>
          </select>
          <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      <!-- Tenant (Société) Filter -->
      <div class="min-w-[180px]">
        <label class="block text-xs font-medium text-gray-500 mb-1.5">Société</label>
        <div class="relative">
          <select [(ngModel)]="selectedTenantId" (change)="onTenantChange()" class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                     focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                     hover:border-gray-300 outline-none cursor-pointer transition-all">
            <option value="">Toutes les sociétés</option>
            @for(tenant of tenants; track tenant.id){
            <option [value]="tenant.id">{{ tenant.name }}</option>
            }
          </select>
          <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      <!-- Project / Task multi-select filter -->
      <div class="project-filter-container min-w-[220px] relative">
        <label class="block text-xs font-medium text-gray-500 mb-1.5">Project / Task</label>
        <!-- Trigger button -->
        <button type="button" (click)="toggleProjectDropdown()"
          class="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm bg-white border border-gray-200
                 hover:border-gray-300 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                 outline-none cursor-pointer transition-all text-left">
          <span class="flex items-center gap-2 min-w-0">
            <svg class="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
            </svg>
            @if (selectedProjects.size === 0) {
              <span class="text-gray-400 truncate">All projects</span>
            } @else if (selectedProjects.size === 1) {
              <span class="text-gray-800 truncate">{{ resolveKeyName(selectedProjects.values().next().value ?? '') }}</span>
            } @else {
              <span class="text-gray-800 truncate">{{ selectedProjects.size }} projects selected</span>
            }
          </span>
          <div class="flex items-center gap-1.5 flex-shrink-0">
            @if (selectedProjects.size > 0) {
              <span class="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-blue-600 text-white">
                {{ selectedProjects.size }}
              </span>
              <button type="button" (click)="$event.stopPropagation(); clearProjectFilter()"
                class="w-4 h-4 flex items-center justify-center rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
                title="Clear project filter">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            }
            <svg class="w-4 h-4 text-gray-400 transition-transform duration-200"
              [class.rotate-180]="projectDropdownOpen"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </button>

        <!-- Dropdown panel -->
        @if (projectDropdownOpen) {
          <div class="absolute top-full left-0 mt-1 w-full min-w-[240px] bg-white border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden">
            <!-- Search inside dropdown -->
            <div class="px-3 pt-3 pb-2 border-b border-gray-100">
              <div class="relative">
                <svg class="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input type="text" [(ngModel)]="projectSearch" placeholder="Search projects…"
                  class="w-full pl-8 pr-3 py-1.5 rounded-lg text-sm bg-gray-50 border border-gray-200
                         focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all" />
              </div>
            </div>

            <!-- Options list -->
            <div class="max-h-52 overflow-y-auto py-1">
              @if (filteredProjectOptions.length === 0) {
                <div class="px-4 py-3 text-sm text-gray-400 text-center">No projects found</div>
              }
              @for (proj of filteredProjectOptions; track proj) {
                <label class="flex items-center gap-3 px-3 py-2 hover:bg-blue-50/60 cursor-pointer transition-colors group">
                  <div class="relative flex-shrink-0">
                    <input type="checkbox" [checked]="selectedProjects.has(proj)" (change)="toggleProject(proj)"
                      class="sr-only" />
                    <div class="w-4 h-4 rounded border-2 flex items-center justify-center transition-all"
                      [class]="selectedProjects.has(proj)
                        ? 'bg-blue-600 border-blue-600'
                        : 'border-gray-300 bg-white group-hover:border-blue-400'">
                      @if (selectedProjects.has(proj)) {
                        <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                        </svg>
                      }
                    </div>
                  </div>
                  <span class="text-sm truncate"
                    [class]="selectedProjects.has(proj) ? 'text-blue-700 font-medium' : 'text-gray-700'">
                    {{ resolveKeyName(proj) }}
                  </span>
                </label>
              }
            </div>

            <!-- Footer -->
            @if (selectedProjects.size > 0) {
              <div class="px-3 py-2 border-t border-gray-100 bg-gray-50/80">
                <button type="button" (click)="clearProjectFilter()"
                  class="text-xs text-gray-500 hover:text-red-600 cursor-pointer transition-colors">
                  Clear all ({{ selectedProjects.size }})
                </button>
              </div>
            }
          </div>
        }
      </div>

      <!-- Results Count -->
      <div class="flex items-center gap-2 py-2">
        <span class="text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-lg font-medium">
          {{ filteredEntries.length }} entries
        </span>
      </div>

      <!-- Export Button (pushed to right) -->
      <div class="ml-auto">
        <button (click)="exportToExcel()" [disabled]="timeEntries.length === 0 || loadingExcel" class="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white
                     bg-emerald-600 hover:bg-emerald-700
                     disabled:opacity-50 disabled:cursor-not-allowed transition-all cursor-pointer shadow-sm
                     focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          @if(loadingExcel) {
          Exporting...
          } @else {
          Export Excel
          }
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="overflow-x-auto">
    <div class="max-h-[500px] overflow-y-auto">
      <table class="w-full text-left">
        <thead class="sticky top-0 z-10 bg-gray-50 border-b border-gray-200">
          <tr class="text-xs font-semibold text-gray-500 uppercase tracking-wide">
            <th class="px-6 py-3">Employee</th>
            <th class="px-4 py-3">Type</th>
            <th class="px-6 py-3">Project / Task</th>
            <th class="px-6 py-3">Time Range</th>
            <th class="px-6 py-3">Duration</th>
            <th class="px-4 py-3">Billable</th>
            <th class="px-4 py-3">Status</th>
            <th class="px-6 py-3">Description</th>
            <th class="px-6 py-3 text-center w-24">Files</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for(timeEntry of filteredEntries; track timeEntry.id) {
          <tr class="hover:bg-blue-50/30 transition-colors">
            <!-- Employee -->
            <td class="px-6 py-4">
              <div class="flex items-center gap-3">
                <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600
                                flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                  {{ getEmployeeName(timeEntry.employeeId!).charAt(0) }}{{
                  getEmployeeName(timeEntry.employeeId!).split(" ")[1]?.charAt(0) || '' }}
                </div>
                <span class="font-medium text-gray-800 text-sm">{{ getEmployeeName(timeEntry.employeeId!) }}</span>
              </div>
            </td>

            <!-- Type badge -->
            <td class="px-4 py-4">
              @if (getEntryType(timeEntry.projectName) === 'CRM Task') {
              <span
                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-purple-50 text-purple-700 border border-purple-100">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                Task
              </span>
              } @else {
              <span
                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                </svg>
                Project
              </span>
              }
            </td>

            <!-- Name -->
            <td class="px-6 py-4">
              <span class="text-sm font-medium text-gray-800">{{ getEntryName(timeEntry.projectName) }}</span>
            </td>

            <!-- Time Range -->
            <td class="px-6 py-4">
              <div class="text-sm text-gray-600 font-mono">
                <div>{{ timeEntry.startTime | date:'MMM d, HH:mm' }}</div>
                <div class="text-gray-400">{{ timeEntry.endTime | date:'MMM d, HH:mm' }}</div>
              </div>
            </td>

            <!-- Duration -->
            <td class="px-6 py-4">
              <span class="text-sm font-medium text-gray-700">
                {{ getDuration(timeEntry.startTime, timeEntry.endTime) }}
              </span>
            </td>

            <!-- Billable -->
            <td class="px-4 py-4">
              @if (timeEntry.billable ?? true) {
              <span
                class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100">$
                Yes</span>
              } @else {
              <span
                class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200">—
                No</span>
              }
            </td>

            <!-- Approval Status -->
            <td class="px-4 py-4">
              @if ((timeEntry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0"></span>
                Approved
              </span>
              } @else {
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-600 border border-gray-200">
                <span class="w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0"></span>
                Draft
              </span>
              }
            </td>
            <!-- Description -->
            <td class="px-6 py-4 max-w-xs">
              @if(timeEntry.content) {
              <p class="text-sm text-gray-600 line-clamp-2" [title]="timeEntry.content">
                {{ timeEntry.content }}
              </p>
              } @else {
              <span class="text-sm text-gray-400 italic">No description</span>
              }
            </td>

            <!-- Images -->
            <td class="px-6 py-4 text-center">
              @if (timeEntry.imagePaths?.length) {
              @if (imagesLoaded) {
              <!-- Image Gallery Modal -->
              <div class="fixed inset-0 bg-black/50 backdrop-blur-sm z-9999 flex items-center justify-center p-4">
                <div class="absolute inset-0" (click)="toggleTimeEntryImages(timeEntry)"></div>
                <div class="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden">
                  <div class="px-6 py-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
                    <h2 class="text-base font-semibold text-gray-900">Attachments ({{ imageUrls.length }})</h2>
                    <button class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100
                                           cursor-pointer transition-all" (click)="toggleTimeEntryImages(timeEntry)">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div class="p-6 overflow-y-auto max-h-[calc(85vh-80px)]">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      @for (img of imageUrls; track img) {
                      <img [src]="img" alt="Time entry attachment"
                        class="w-full h-auto rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow" />
                      }
                    </div>
                  </div>
                </div>
              </div>
              } @else {
              <button class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium
                                     bg-gray-100 text-gray-600 hover:bg-gray-200
                                     transition-all cursor-pointer" (click)="toggleTimeEntryImages(timeEntry)">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {{ timeEntry.imagePaths?.length }}
              </button>
              }
              } @else {
              <span class="text-xs text-gray-300">—</span>
              }
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="9" class="px-6 py-16 text-center">
              <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p class="text-gray-500 font-medium">No time entries found</p>
              <p class="text-sm text-gray-400 mt-1">Try adjusting your filters</p>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Load More -->
  @if(hasMoreData) {
  <div class="px-6 py-4 border-t border-gray-100 bg-gray-50/50 flex justify-center">
    <button (click)="onLoadMore()" [disabled]="loadingMore" class="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium
                   text-blue-600 bg-blue-50 border border-blue-200
                   hover:bg-blue-100 hover:border-blue-300
                   disabled:opacity-50 transition-all cursor-pointer">
      @if(loadingMore) {
      <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
      </svg>
      Loading...
      } @else {
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
      Load more entries
      }
    </button>
  </div>
  }
  } @else {
  <!-- Loading State -->
  <div class="py-16 text-center">
    <div class="w-10 h-10 rounded-full border-4 border-emerald-100 border-t-emerald-600 animate-spin mx-auto mb-4">
    </div>
    <p class="text-gray-500 text-sm">Loading time entries...</p>
  </div>
  }
</div>